import { Sort } from '../../../insight/experimental.grid';

export interface CellContext {
    templateId: TemplateID;
    data: any[];
}

export enum OptionalColumnType {
    ACTUAL,
    TARGET,
    PERCENT_TO_TARGET,
    WEIGHT,
    ACTUAL_TYPE,
    TARGET_TYPE,
    PERCENT_TYPE,
    SCORING_TYPE,
    USER_NAME,
    SUPERGROUP_NAME,
    ACTUAL_TREND,
    PERCENT_TO_TARGET_TREND,
    COACHING_PLAN_ACTIVE,
    METRIC_LABEL,
}
export interface OptionalColumn {
    columnType: OptionalColumnType;
    displayOrder: number;
}
export enum RankColumnType {
    ADJUSTED_POINTS,
    RANK,
    MAX_RANK,
    MY_RANK,
    SUPERGROUP_NAME,
    DIRECT_REPORTS,
    PERIOD,
    SUPERGROUP_OVERALL_RANK,
    SITE_SUPERGROUP_RANK,
    ROLE_OVERALL_RANK,
    ROLE_BY_REGION_RANK,
    PEER_GROUP_OVERALL_RANK,
    LOB_OVERALL_RANK,
}

export interface DirectReportRankResult {
    scorecardId: number;
    subScorecardId?: number;
    subUserId: number;
    subUserName: string;
    subSuperGroupId: number;
    subSuperGroupName: string;
    subStartDate: string;
    subEndDate: string;
    subAdjustedPoints?: number;
    rankType?: number;
    myRank?: number;
    maxRank?: number;
    sortDefs: Sort[];
}

export interface DirectReportRankDisplay {
    subScorecardId: number;
    subUserId: number;
    directReport: string;
    subSuperGroupName: string;
    subSuperGroupId: number;
    period: string;
    startDate: string;
    endDate: string;
    overallScore: number;
    superGroupOverallRank: string;
    siteSuperGroupRank: string;
    roleOverallRank: string;
    roleByRegionRank: string;
    rankType: number;
    myRank: number;
    peerGroupOverallRank: string;
    lobOverallRank: string;
    sortDefs: Sort[];
}

export enum TemplateID {
    HEADER_GROUP = 'headerGroup',
    HEADER = 'header',
    CONTENT = 'content',
}

export interface RankColumnContext {
    templateId: TemplateID;
    type: RankColumnType;
}

export interface RankCellContext {
    templateId: TemplateID;
    data: DirectReportRankDisplay;
}
